import React from 'react'
import { Box, Stack, Typography } from "@mui/material"
import CalificacionA from '../../images/navegante-estelar.svg'
import CalificacionB from '../../images/capitan.svg'
import CalificacionC from '../../images/navegante-digital.svg'
import CalificacionD from '../../images/explorador.svg'
import colors from '../../theme/colors'
import { t } from 'i18next'
import { useColors } from '../../hooks/useColors'

export const CalificationWithImageAndText = ({ calification, width, grafico }) => {

    const { getCalificationColor } = useColors()
    let calificationImage
    let textCalificationImage
    let texDescriptiontCalificationImage
    let colorCalificationImage

    switch (calification) {
        case "A":
            calificationImage = CalificacionA
            textCalificationImage = "Resultado.alto"
            texDescriptiontCalificationImage = "cuestion.LeyendaTextoA"
            colorCalificationImage = "cuestion.LeyendaEtapaA"
            break;
        case "B":
            calificationImage = CalificacionB
            textCalificationImage = "Resultado.medioAlto"
            texDescriptiontCalificationImage = "cuestion.LeyendaTextoB"
            colorCalificationImage = "cuestion.LeyendaEtapaB"
            break;
        case "C":
            calificationImage = CalificacionC
            textCalificationImage = "Resultado.medioBajo"
            texDescriptiontCalificationImage = "cuestion.LeyendaTextoC"
            colorCalificationImage = "cuestion.LeyendaEtapaC"
            break;
        case "D":
        default:
            calificationImage = CalificacionD
            textCalificationImage = "Resultado.bajo"
            texDescriptiontCalificationImage = "cuestion.LeyendaTextoD"
            colorCalificationImage = "cuestion.LeyendaEtapaD"
            break;
    }

    return (
        <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={2}
            sx={grafico && { width: 225 }}
        >
            <Typography
                variant='parrafo'
                fontWeight={"bold"}
                color={
                    getCalificationColor(t(colorCalificationImage))
                }
                textAlign='right'
            >
                <Stack
                    direction='column'
                    spacing={0}
                    alignItems="center"
                >
                    <Box>
                        {t(textCalificationImage)}
                    </Box>
                    <Box>
                    {t(texDescriptiontCalificationImage)}
                    </Box>
                </Stack>
            </Typography>
            <Box component={'img'} width={width} height={'auto'} src={calificationImage} alt={calificationImage} />
        </Stack>
    )
}
